import React from 'react';
import { IconLoader } from '../../../common/IconLoader';
import styles from './LandingLayout.module.css';

function LandingLayout({ children }) {
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.header}>
          <img src={IconLoader.icon_ibms_wide_white} alt="Pivotal | IBMS" />
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  );
}

export default LandingLayout;
